import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../../icon/types';

export const SentimentNegativeIcon = (props: IconProps) => (
  <ChakraIcon
    width="16"
    height="16"
    viewBox="0 -0.2 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33337 8.00016 1.33337C4.31826 1.33337 1.3335 4.31814 1.3335 8.00004C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667ZM5.19546 5.1953C4.93511 5.45565 4.93511 5.87776 5.19546 6.13811L7.08107 8.02372L5.19542 9.90937C4.93508 10.1697 4.93508 10.5918 5.19542 10.8522C5.45577 11.1125 5.87788 11.1125 6.13823 10.8522L8.02388 8.96653L9.9095 10.8522C10.1699 11.1125 10.592 11.1125 10.8523 10.8522C11.1127 10.5918 11.1127 10.1697 10.8523 9.90935L8.96669 8.02372L10.8523 6.13813C11.1126 5.87778 11.1126 5.45567 10.8523 5.19532C10.5919 4.93497 10.1698 4.93497 9.90947 5.19532L8.02388 7.08091L6.13827 5.1953C5.87792 4.93495 5.45581 4.93495 5.19546 5.1953Z"
      fill="#FA5757"
    />
  </ChakraIcon>
);
